import { Component, OnInit } from '@angular/core'
import { Router, NavigationStart, RouterOutlet } from '@angular/router'
import { MENU_PERMISSION_SECTIONS } from '@models'
import { AuthService } from '@services'
import { ToastContainerComponent } from 'common/utils/toast/toast-container.component'
import { filter } from 'rxjs/operators'

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastContainerComponent],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  async ngOnInit(): Promise<void> {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe(async (event: NavigationStart) => {
        const hasPermission = await this.checkPermission(event.url)
        if (!hasPermission) {
          this.router.navigate(['/'])
        }
      })
  }

  async checkPermission(url: string): Promise<boolean> {
    if (!url || url == '/') return true

    const urlPrefix = url.split('?')
    if (urlPrefix && urlPrefix[0]) {
      if (urlPrefix[0] == '/forgot-password' || urlPrefix[0] == '/reset-password') return true
    }

    url = url.split('?')[0].split('/')[2]

    for (let i = 0; i < MENU_PERMISSION_SECTIONS.length; i++) {
      const items = MENU_PERMISSION_SECTIONS[i].items
      if (items) {
        for (let j = 0; j < items.length; j++) {
          if (items[j].key == url && items[j].allowAccess) return true
        }
      }
    }

    const tenantActive = await this.authService.getTenantActive()
    const userInfo = await this.authService.getUserInfo()
    if (userInfo) {
      const tenant = userInfo.Tenants.filter((x) => x.Id == tenantActive?.id)[0]
      if (tenant && tenant.Roles) {
        const hasPermission = tenant.Roles.includes(url)
        if (hasPermission) return hasPermission
      }
    }

    return false
  }
}
